import { render, staticRenderFns } from "./SecoesRodape.vue?vue&type=template&id=cf27ba76"
import script from "./SecoesRodape.vue?vue&type=script&lang=js"
export * from "./SecoesRodape.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports